import { PostResponse } from "../typings";
import axios from "infra/http";
import { useQuery } from "react-query";

function usePost(id?: string) {
  return useQuery(
    `/v1/mural/${id}`,
    async () => {
      const res = await axios.get<PostResponse>(`/v1/mural/${id}`);

      return res.data;
    },
    {
      enabled: !!id,
    }
  );
}

export default usePost;
